import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmail = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M14.168 17.5832H5.83464C3.33464 17.5832 1.66797 16.3332 1.66797 13.4165V7.58317C1.66797 4.6665 3.33464 3.4165 5.83464 3.4165H14.168C16.668 3.4165 18.3346 4.6665 18.3346 7.58317V13.4165C18.3346 16.3332 16.668 17.5832 14.168 17.5832Z",
		stroke: "currentColor",
		strokeWidth: 1.25,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14.1654 8L11.557 10.0833C10.6987 10.7667 9.29036 10.7667 8.43203 10.0833L5.83203 8",
		stroke: "currentColor",
		strokeWidth: 1.25,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export { SvgEmail as ReactComponent };
